export default [
  { name: 'Monthly' },
  { name: 'Quarterly' },
  { name: 'Bi-Annually' },
  { name: 'Annually' },
];
